import { PanelLeftIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSidebar } from "@/components/ui/sidebar";
import { useSidebarPeek } from "@/components/layout/SidebarPeek";
import { cn } from "@/lib/utils";

export function AppSidebarTrigger({ className }) {
  const { toggleSidebar } = useSidebar();
  const { pinOpen } = useSidebarPeek();

  return (
    <Button
      type="button"
      data-sidebar="trigger"
      data-slot="sidebar-trigger"
      variant="ghost"
      size="icon-sm"
      className={cn(
        "touch-target-icon shrink-0 text-muted-foreground shadow-none hover:text-foreground",
        className,
      )}
      aria-label="Toggle sidebar"
      aria-keyshortcuts="Control+B"
      title="Toggle sidebar (Ctrl+B)"
      onClick={() => {
        pinOpen();
        toggleSidebar();
      }}
    >
      <PanelLeftIcon />
      <span className="sr-only">Toggle sidebar</span>
    </Button>
  );
}
